export const getPlayerSelectorWidth = (totalPlayers) => {
  if (totalPlayers === 1) return `95%`;
  if (totalPlayers % 2 === 0) return `48%`;
  return `31%`;
};
